export default __webpack_public_path__ + "static/media/10、900ml常温果汁.2ae16a06.jpg";